import { Spin } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../store/rootReducer';
import RepaymentMobileView from './MobileView';
import RepaymentTableView from './TableView';

const RepaymentSchedules: React.FC = () => {
    const loading = useSelector((state: RootState) => state.investments.cLoading);

    return (
        <div className="px-6 pb-4">
            {!loading && (
                <>
                    <div className="hidden md:block">
                        <RepaymentTableView />
                    </div>
                    <div className="block md:hidden">
                        <RepaymentMobileView />
                    </div>
                </>
            )}
            {loading && (
                <div className="flex justify-center items-center h-40">
                    <Spin />
                </div>
            )}
        </div>
    );
};

export default RepaymentSchedules;
